export const ingredientReplacementSteps = {
  INGREDIENT_REPLACEMENT_STEP: 1,
  SET_QUANTITY_STEP: 2,
};

export const ingredientReplacementActions = {
  RESOLVE: "RESOLVE",
  CLOSE: "CLOSE",
  RESOLVE_CLOSE: "RESOLVE_CLOSE",
  DIRECT_TO_LOCATION: "DIRECT_TO_LOCATION",
};

export const ingredientReplacementStatuses = {
  RESOLVED: "RESOLVED",
  UNRESOLVED: "UNRESOLVED",
  CLOSED: "CLOSED",
  EXPIRED: "EXPIRED",
};

export const ingredientReplacementTypes = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  INFO: "INFO",
};

export const ingredientReplacementCategory = {
  GLOBAL_PRICING: "GLOBAL_PRICING",
};

/**
 * Source of the global-pricing resolve modal.
 * Can access from notification center, ingredient section, etc.
 */
export const source = {
  NOTIFICATIONS: "NOTIFICATIONS",
  INGREDIENT_SECTION: "INGREDIENT_SECTION",
};

export const resolveBypassSet = [source.INGREDIENT_SECTION]; // sources which can bypass notification center to resolve modal
